module.exports = __webpack_public_path__ + "static/media/speaker-deck.db33b2fc.svg";